var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatabaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_100",
    "data-name": "Group 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100-2",
    "data-name": "Group 100",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M17.872,269.283h-.911a6.936,6.936,0,0,0-1.813-.134q-2.439-.163-4.849-.493a35.062,35.062,0,0,1-5.861-1.248,11.363,11.363,0,0,1-3.364-1.582c-.459-.341-.943-.748-.946-1.308-.022-3.253-.007-6.506,0-9.759l.444.62.09.085a4.344,4.344,0,0,0,1.426,1,15.152,15.152,0,0,0,4.277,1.423l.124.069,1.281.31.271.006a.361.361,0,0,0,.069.005.415.415,0,0,0,.291.068l.191.074.265,0,.243.012.212.065.167.009a.554.554,0,0,0,.379.069l.279.078H10.4l.246.013a.462.462,0,0,0,.3.065l.37.078h.269l.369.077.269,0,.46.076h.449l.46.08.36,0a31.264,31.264,0,0,0,3.837.226,74.293,74.293,0,0,0,10.772-.443,38.794,38.794,0,0,0,8-1.684,7.547,7.547,0,0,0,3.021-1.739c.161-.166.229-.4.495-.492q0,4.587.011,9.173a2.292,2.292,0,0,1-1.218,1.888,12.541,12.541,0,0,1-3.7,1.585,39.972,39.972,0,0,1-6.712,1.267c-1.67.173-3.334.358-5.018.38-.1,0-.218-.035-.28.075h-1a3.294,3.294,0,0,0-1.548,0h-1a4.056,4.056,0,0,0-1.73,0",
    transform: "translate(-0.104 -229.283)",
    fill: "#2387ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M154.506,399.153a4.057,4.057,0,0,1,1.73,0Z",
    transform: "translate(-136.738 -359.153)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M178.263,399.163a3.3,3.3,0,0,1,1.548,0Z",
    transform: "translate(-157.763 -359.163)",
    fill: "#57a3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M40.125,154.286c.006,2.186.024,4.372.012,6.557a15.077,15.077,0,0,1-.081,2.8c-.044.227.126.425.077.646-.266.087-.334.326-.495.492a7.548,7.548,0,0,1-3.021,1.739,38.808,38.808,0,0,1-8,1.684,74.285,74.285,0,0,1-10.772.443,31.267,31.267,0,0,1-3.837-.226.291.291,0,0,0-.36,0l-.46-.081a.4.4,0,0,0-.449,0l-.46-.076a.2.2,0,0,0-.269,0l-.369-.077a.2.2,0,0,0-.269,0l-.37-.078a.453.453,0,0,0-.3-.065l-.246-.013a.2.2,0,0,0-.268,0l-.279-.078a.6.6,0,0,0-.379-.069l-.167-.009-.212-.065-.243-.012a.2.2,0,0,0-.265,0l-.191-.074a.445.445,0,0,0-.291-.068.364.364,0,0,1-.069-.005.2.2,0,0,0-.271-.006l-1.281-.31-.124-.069a15.153,15.153,0,0,1-4.277-1.423,4.342,4.342,0,0,1-1.426-1l-.09-.085-.444-.62q0-5.035,0-10.07a3.192,3.192,0,0,0,1.107,1.26,13.371,13.371,0,0,0,4.228,1.762,42.778,42.778,0,0,0,5.631,1.061,62.315,62.315,0,0,0,6.6.5,75.14,75.14,0,0,0,10.927-.449,39.963,39.963,0,0,0,7.115-1.412,7.857,7.857,0,0,0,4.269-2.5h.062",
    transform: "translate(-0.163 -138.658)",
    fill: "#57a3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M109.4,296.232a.4.4,0,0,1,.449,0H109.4",
    transform: "translate(-96.815 -266.547)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M81.5,292.236a.6.6,0,0,1,.379.069.553.553,0,0,1-.379-.069",
    transform: "translate(-72.128 -263.01)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M117.3,297.084a.291.291,0,0,1,.36,0l-.36,0",
    transform: "translate(-103.809 -267.319)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M66.639,289.371a.2.2,0,0,1,.271.007l-.271-.007",
    transform: "translate(-58.976 -260.39)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M69.6,289.916a.445.445,0,0,1,.291.068.415.415,0,0,1-.291-.068",
    transform: "translate(-61.593 -260.923)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M73.782,290.923a.2.2,0,0,1,.265,0l-.265,0",
    transform: "translate(-65.297 -261.788)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M87.218,293.273a.2.2,0,0,1,.268,0h-.268",
    transform: "translate(-77.188 -263.9)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M91.684,293.843a.452.452,0,0,1,.3.065.461.461,0,0,1-.3-.065",
    transform: "translate(-81.14 -264.457)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M97.513,294.836a.2.2,0,0,1,.269,0h-.269",
    transform: "translate(-86.299 -265.307)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M103.056,295.618a.2.2,0,0,1,.269,0l-.269,0",
    transform: "translate(-91.205 -266.011)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M78.2,291.516l.212.065-.212-.065",
    transform: "translate(-69.206 -262.364)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M4.048,260.956l.09.085-.09-.085",
    transform: "translate(-3.582 -234.86)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M54.427,286.022l.124.069-.124-.069",
    transform: "translate(-48.168 -257.42)",
    fill: "#59a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M40.093,64.32a7.857,7.857,0,0,1-4.269,2.5,39.96,39.96,0,0,1-7.114,1.412,75.14,75.14,0,0,1-10.927.449,62.317,62.317,0,0,1-6.6-.5,42.8,42.8,0,0,1-5.631-1.061,13.369,13.369,0,0,1-4.228-1.762A3.192,3.192,0,0,1,.217,64.1q0-5,0-10A3.977,3.977,0,0,0,2.1,55.839a20.716,20.716,0,0,0,5.388,1.738,58.134,58.134,0,0,0,10.12,1.1c2.317.08,4.64.049,6.957-.075.467-.025.939-.036,1.4-.091,1.228-.144,2.459-.27,3.687-.411,1.326-.152,2.6-.464,3.9-.691a18.338,18.338,0,0,0,2.96-.867c1.494-.53,2.912-1.1,3.644-2.444q0,5,0,10l-.071.222",
    transform: "translate(-0.192 -48.691)",
    fill: "#99c7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M39.972,5.41c-.732,1.346-2.151,1.914-3.644,2.444a18.337,18.337,0,0,1-2.96.867c-1.3.227-2.577.539-3.9.691-1.228.141-2.459.267-3.687.411-.464.054-.936.066-1.4.091-2.317.124-4.641.155-6.957.075A58.135,58.135,0,0,1,7.3,8.886,20.716,20.716,0,0,1,1.909,7.148,3.977,3.977,0,0,1,.026,5.41,2.008,2.008,0,0,1,1.038,3.433a10.8,10.8,0,0,1,3.3-1.528A41.681,41.681,0,0,1,12.4.387,71.341,71.341,0,0,1,21.154.014a59.49,59.49,0,0,1,12.717,1.4,15.162,15.162,0,0,1,4.794,1.824c.827.538,1.46,1.187,1.308,2.171",
    transform: "translate(0 0)",
    fill: "#bdd9ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/databaseIcon.2633c56ea11cf99e8b3ddd8675c09b64.svg";
export { ForwardRef as ReactComponent };